import { type ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { Dropdown } from '@bosch/react-frok'

import useGenericStore from '@/hooks/useGenericStore'

import './LanguageSwitch.scss'

const LanguageSwitch = () => {
    const { i18n } = useTranslation()
    const { setGenericStoreValue } = useGenericStore()

    const onLanguagechange = (event: ChangeEvent<HTMLSelectElement>): void => {
        i18n.changeLanguage(event.target.value)
        setGenericStoreValue('language', event.target.value, true)
    }

    const languages = Object.keys(i18n.services.resourceStore.data).filter(
        (key) =>
            key.length === 2 &&
            Object.keys(i18n.services.resourceStore.data[key] ?? {}).length > 0
    )

    const options = languages
        .map((lang) => {
            const raw = new Intl.DisplayNames([lang], { type: 'language' }).of(lang) ?? lang
            const name = /^[a-zA-ZÀ-ÖØ-öø-ÿ]/.test(raw)
                ? raw[0].toLocaleUpperCase() + raw.slice(1)
                : raw
            return { name, value: lang }
        })
        .sort((a, b) => a.name.localeCompare(b.name))

    return (
        <Dropdown
            className="language-switch"
            options={options}
            onChange={onLanguagechange}
            value={i18n.resolvedLanguage ?? 'en'}
        />
    )
}

export { LanguageSwitch }
